const isDev = import.meta.env.DEV;

type LogLevel = 'log' | 'info' | 'warn' | 'error';

function makeLogger(namespace: string) {
  const prefix = `[${namespace}]`;

  function write(level: LogLevel, ...args: unknown[]) {
    if (!isDev) return;
    console[level](prefix, ...args);
  }

  return {
    log: (...args: unknown[]) => write('log', ...args),
    info: (...args: unknown[]) => write('info', ...args),
    warn: (...args: unknown[]) => write('warn', ...args),
    error: (...args: unknown[]) => write('error', ...args),
  };
}

export const logger = makeLogger('App');
export { makeLogger };
